import { css, styled } from 'styled-components';

import CloseIcon from '../../../assets/icons/close-icon.svg?react';
import { LeftColSC, RightColSC } from '../../components/common/Common';
import { IconButton } from '../button/IconButton';
import { Heading } from '../heading/Heading';

export const lightHeader = css`
  color: ${(props) => props.theme.colors.oxfordBlue[100]};
  border-bottom: 1px solid ${(props) => props.theme.colors.slateGray[50]};
`;
export const darkHeader = css`
  color: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.oxfordBlue[80]};
`;

const HeaderSC = styled.div<{ $align?: 'start' | 'center'; $colorVariant?: 'light' | 'dark' }>`
  ${(props) => {
    if (props.$colorVariant === 'dark') {
      return darkHeader;
    }

    return lightHeader;
  }}

  position: relative;
  padding: 0 0 1.0625rem 0;
  width: 100%;
  display: flex;
  justify-content: ${(props) => props.$align};
  align-items: center;
  text-align: ${(props) => props.$align};

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
  }
`;

const ButtonSC = styled(IconButton)`
  padding: 0;

  svg {
    color: ${(props) => props.theme.colors.oxfordBlue[30]};
  }

  &:focus {
    svg {
      color: ${(props) => props.theme.colors.oxfordBlue[50]};
    }
  }
`;

type Props = {
  align?: 'start' | 'center';
  backButton?: React.ReactElement;
  buttonName?: string;
  colorVariant?: 'light' | 'dark';
  heading: string;
  onClose: () => void;
};

export const ModalHeader = ({ align, backButton, buttonName, colorVariant, heading, onClose }: Props) => {
  return (
    <HeaderSC $align={align} $colorVariant={colorVariant}>
      {backButton && <LeftColSC>{backButton}</LeftColSC>}
      <Heading $uppercase as="h3">
        {heading}
      </Heading>
      <RightColSC>
        <ButtonSC name={buttonName} onClick={onClose}>
          <CloseIcon />
        </ButtonSC>
      </RightColSC>
    </HeaderSC>
  );
};
